export default "__VITE_ASSET__CxYJOdUe__"